import { FC } from 'react'

import { aboutInfoData, companyDescription, contrastInfoBlock, heroBannerData } from './data'
import { BigHeroBanner } from './ui/BigHeroBanner/BigHeroBanner'
import { CompanyDescription } from './ui/CompanyDescription/CompanyDescription'
import { ContrastInfoBlock } from './ui/ContrastInfoBlock/ContrastInfoBlock'
import { InfoSectionBlock } from './ui/InfoSection/InfoSectionBlock'

export const AboutIport: FC = () => {
	return (
		<>
			<BigHeroBanner {...heroBannerData} />
			<InfoSectionBlock data={aboutInfoData} />
			<ContrastInfoBlock {...contrastInfoBlock} />
			<CompanyDescription description={companyDescription} />
		</>
	)
}
